import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import router from './router'
import App from './App.vue'
import store from './store'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import "./utils/permission"
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)
import api from "./api"

Vue.config.productionTip = false
Vue.prototype.$api = api

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
